<template>
    <div class="conference_main_box">
        <meetingPage></meetingPage>
    </div>
</template>

<script>
/* eslint-disable */
import meetingPage from '@/components/private/jitsi/meetingPage';
export default {
    name: "video-confreness-page",
    components: {
        meetingPage
    },
};
</script> 